import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { Button, Drawer, Switch, Modal, Input, message } from 'antd';
import { EditFilled, DeleteFilled, CopyOutlined } from '@ant-design/icons';
import {
  PhoneOutlined,

  PauseOutlined,
  SwapOutlined,
  CaretRightOutlined,
  AudioMutedOutlined,
  AudioOutlined,
} from "@ant-design/icons";

import { Typography, Space, Alert, Result } from 'antd';
import { ReloadOutlined, CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import useAxios from './../../../CustomHooks/useAxios';


import Edit from "./Edit";
import Delete from "./Delete";
const { Text, Title } = Typography;

export default function ShowTable({ data, setRefressSearch }) {


  const { axiosi } = useAxios();

  const hideItem = useSelector((state) => state.loginReducer.hideItem);

  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleRemove, setVisibleRemove] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [newToken, setNewToken] = useState("");
  const handleEdit = (item) => {
    console.log("[handleEdit]:item=", item);
    setSelectedItem(item);
    setVisibleEdit(true);
  }
  const handleRemove = (item) => {
    console.log("[handleRemove]:item=", item);
    setVisibleRemove(true);
    setSelectedDeleteItem(item);
  }

  const onCloseEdit = () => {
    console.log("[onCloseEdit]")
    setSelectedItem(null);
    setVisibleEdit(false);
  }
  const onCloseRemove = () => {
    setVisibleRemove(false);
    setSelectedDeleteItem(null);
  }

  async function onChange(checked, item) {
    console.log(`switch to ${checked}`, item);

    try {
      const kq = await axiosi.put(`surveyplan/${item.id}/running`, { runplan: checked, numcurrentcall: item.numcurrentcall });
      console.log("[onFinishAdd]:kq=", kq);
      // form.resetFields();
      // setSelectedItem(null);
      // setVisibleEdit(false);
      setRefressSearch(pre => !pre);
    } catch (error) {
      console.log("eror");
    }
  }


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleShowModalRegenerateToken = async (item) => {
    console.log("[handleRegenerateToken]:item=", item);
    setSelectedItem(item);
    setNewToken("");
    showModal();
    return;
    try {
      const kq = await axiosi.put(`autocall_settings/reGenerateToken/${item.id}/`, { company_id: item.company_id });
      console.log("[handleRegenerateToken]:kq=", kq);
      setRefressSearch(pre => !pre);
    } catch (error) {
      console.log("eror");
    }
  }
  const handleRegenerateToken = async (item) => {



    // return;
    try {
      const kq = await axiosi.put(`autocall_settings/reGenerateToken/${item.id}/`, { company_id: item.company_id });
      console.log("[handleRegenerateToken]:kq=", kq);

      setNewToken(kq.data.token);
    } catch (error) {
      console.log("eror");
    }
  }
  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    message.info({
      content: "copied !",
      className: "custom-class",
      style: {
        position: "absolute",
        top: "-15px",
        right: "1px",
      },
    });
  };
  return (
    <>
      <Modal
        title={
          <Space>

            <span>&emsp;<b>Regenerate Token</b></span>
          </Space>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        centered
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>
        ]}
      >
        <div style={{ padding: '10px 0' }}>
          {newToken === "" ? (
            /* Trạng thái 1: Xác nhận trước khi tạo mới */
            <Result
              status="warning"
              title="Are you sure?"
              subTitle="Regenerating will invalidate the current token. This action cannot be undone."
              extra={[
                <Button
                  type="primary"
                  danger
                  key="confirm"
                  icon={<ReloadOutlined />}
                  onClick={() => handleRegenerateToken(selectedItem)}
                >
                  Yes, Regenerate Token
                </Button>,
              ]}
            />
          ) : (
            /* Trạng thái 2: Hiển thị Token mới */
            <div style={{ textAlign: 'center' }}>
              <Result
                status="success"
                title="Token Regenerated Successfully!"
              />
              <Alert
                message="New Token Key"
                description={
                  <div style={{ marginTop: 5 }}>
                    <Text
                      code
                      // Quan trọng: copyable vẫn giữ newToken gốc để người dùng dán ra là full mã
                      copyable={{ text: newToken }}
                      style={{
                        fontSize: '16px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '12px',
                        background: '#f5f5f5',
                        borderRadius: '4px',
                        border: '1px dashed #d9d9d9'
                      }}
                    >
                      {/* Chỉ hiển thị 8 ký tự đầu ... và 8 ký tự cuối */}
                      {newToken.length > 16
                        ? `${newToken.substring(0, 8)} •••••••••••• ${newToken.slice(-8)}`
                        : newToken}
                    </Text>
                  </div>
                }
                type="info"
                showIcon
              />
              <p style={{ color: 'red', marginTop: "10px" }}>Please copy and save it, it will not show again!</p>
              <Button
                type="primary"
                icon={<CopyOutlined />}
                style={{ marginTop: 20 }}
                onClick={() => handleCopy(newToken)}
              >
                Copy to Clipboard
              </Button>
            </div>
          )}
        </div>
      </Modal>
      <Drawer title="Edit  Autocall setting Item" placement="right" onClose={onCloseEdit} visible={visibleEdit}>
        {selectedItem && <Edit item={selectedItem} setSelectedItem={setSelectedItem} setRefressSearch={setRefressSearch} setVisibleEdit={setVisibleEdit} />}
      </Drawer>

      <Drawer title="Remove  Autocall setting Item" placement="right" onClose={onCloseRemove} visible={visibleRemove}>
        {selectedDeleteItem && <Delete item={selectedDeleteItem} setRefressSearch={setRefressSearch} setVisibleRemove={setVisibleRemove} />}
      </Drawer>

      <table className='table1'>
        <thead>
          <tr>
            <th width="220px" className={hideItem}>company_name</th>
            <th>Name</th>
            <th>Main IVR Plan</th>
            <th>PBX Tel</th>
            <th>Note</th>

            <th width="120px">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id}>

              <td className={hideItem}>{item.company_name}</td>
              <td>{item.token_name}</td>
              <td>{item.main_dialplan_name}</td>
              <td>{item.telout}</td>
              <td>{item.note}</td>

              <td>
                <div className='rowFlex'>
                  <Button onClick={() => handleEdit(item)} icon={<EditFilled style={{ color: 'hotpink' }} />}>Edit</Button>
                  <Button onClick={() => handleRemove(item)}><DeleteFilled style={{ color: 'red' }} />Remove</Button>
                </div>
                <div className='rowFlex' style={{ marginTop: '10px' }}>
                  <Button onClick={() => handleShowModalRegenerateToken(item)}>Regenerate Token</Button> <br />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


    </>
  )
}